import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {
    LoginPage,
    Dashboard,
    ServiceType,
    MainServices,
    SubServices,
    Testimonials,
    Portfolio,
    BackgroundVideo,
    SubServiceImages,
    Links,
    Unauthorized
} from './pages';
import MainLayout from './components/MainLayout';
import { useAuth } from './context/authContext';
import { Navigate } from 'react-router-dom';

const Protected = ({ children }) => {
    const { user } = useAuth();
    console.log(user)
    return (user) ? children : <Navigate to="/UnAuthorized" replace />
}

function App() {
    return (
        <Router>

            <Routes>
                <Route path='/' element={<LoginPage />} />
                <Route path="/UnAuthorized" element={<Unauthorized />} />

                <Route path='admin' element={<Protected><MainLayout /></Protected>}>
                    <Route index element={<Dashboard />} /> { /* Default for /admin */}
                    <Route path="service-type" element={<ServiceType />} />
                    <Route path="main-services" element={<MainServices />} />
                    <Route path="sub-services" element={<SubServices />} />
                    <Route path="testimonials" element={<Testimonials />} />
                    <Route path="portfolio" element={<Portfolio />} />
                    <Route path="background-video" element={<BackgroundVideo />} />
                    <Route path="sub-service-images" element={<SubServiceImages />} />
                    <Route path="links" element={<Links />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;

